var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.54 56.23c2.52 0 5.06.76 7.27 2.33l80.2 57.29 80.19-57.29c5.63-4.02 13.45-2.72 17.47 2.91 4.02 5.63 2.72 13.45-2.91 17.47l-87.47 62.49a12.527 12.527 0 0 1-14.56 0L5.26 78.94C-.37 74.92-1.67 67.1 2.35 61.47c2.43-3.42 6.28-5.24 10.19-5.24z"
  })));
};
export default SvgChevronDown;